import { shades } from "@/styles/theme";
import { Box, Card, CardContent, Typography } from "@mui/material";

interface Industry {
  icon: React.ReactNode;
  name: string;
}

const IndustryCard = ({ industry }: { industry: Industry }) => {
  return (
    <Box
      sx={{
        display: "flex",
        marginTop: 2,
        justifyContent: "center",
      }}
    >
      <Card
        sx={{
          width: "180px",
          height: "120px",
          boxShadow: "0px 10px 10px 5px rgba(0,0,0,0.2)",
          borderRadius: "15px",
          "&:hover": {
            color: "white",
            boxShadow: "0px 5px 8px 5px rgba(0,0,0,0.5)",
            backgroundColor: shades.primary[400],
          },
        }}
      >
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            "&:hover": {
              ".iconContainer": {
                color: "white",
              },
            },
          }}
        >
          <Box
            className="iconContainer"
            sx={{
              color: shades.primary[400],
            }}
          >
            {industry.icon}
          </Box>
          <Typography variant="h4" textAlign="center">
            {industry.name}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default IndustryCard;
